import { analytics } from 'segment_analytics'
import { useStats } from '../../../lib/ctx/stats'
import { useStatsPermission, useStatsZeroState } from '../../../lib/hooks'
import { ReaderInsight } from '../../shared/ReaderInsight'
import { StatsProfileBox } from '../../shared/stats_profile_box'
import { MostReadAuthorsContent } from './MostReadAuthorsContent'

export const MostReadAuthors = () => {
  const yearStatus = useStats((s) => s.yearStatus)
  const zeroState = useStatsZeroState('authors')
  const { isStatsOwner } = useStatsPermission()
  const id = 'most-read-authors'

  return (
    <StatsProfileBox
      id={id}
      data-testid={`stats-${id}`}
      text={{
        top: `Most read${!zeroState ? '' : ' authors'}`,
        main: !zeroState ? 'Authors' : 'None',
        unit: '',
        infoText:
          'Add 2 or more books written by the same author to your Finished list, and we’ll highlight your most read authors here.',
      }}
      footer={
        isStatsOwner && zeroState && yearStatus === 'current' ? (
          <ReaderInsight
            data-testid="reader-insight-authors"
            label="How to get started"
            text="Add 2 or more books written by the same author to your Finished list,
        and we’ll highlight your most read authors here."
          />
        ) : null
      }
      screenshot={{
        enabled: !zeroState,
        component: <MostReadAuthorsContent skipAnim />,
        onClick: () =>
          analytics.events.stats.statsShareTap({ type: 'authors' }),
      }}
    >
      {zeroState ? null : <MostReadAuthorsContent />}
    </StatsProfileBox>
  )
}
